module.exports = __webpack_public_path__ + "static/media/CircleInline.0ba01936.svg";